import { render } from "./Withdrawal-details.vue?vue&type=template&id=f3074f3e"
import script from "./Withdrawal-details.vue?vue&type=script&lang=js"
export * from "./Withdrawal-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__